var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_14815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6876 0H4.31206C1.93062 0 0 1.93055 0 4.31206V27.6878C0 30.0693 1.93055 31.9998 4.31206 31.9998H15.8408L15.8604 20.5648H12.8896C12.5035 20.5648 12.1902 20.2526 12.1887 19.8666L12.1744 16.1806C12.173 15.7924 12.4873 15.4769 12.8754 15.4769H15.8409V11.9153C15.8409 7.78215 18.3652 5.53159 22.0522 5.53159H25.0778C25.4649 5.53159 25.7788 5.84542 25.7788 6.23259V9.34063C25.7788 9.72764 25.4651 10.0414 25.0782 10.0416L23.2214 10.0425C21.2163 10.0425 20.828 10.9953 20.828 12.3936V15.477H25.234C25.6538 15.477 25.9795 15.8436 25.9301 16.2605L25.4932 19.9465C25.4514 20.2992 25.1523 20.565 24.7971 20.565H20.8477L20.828 32H27.6878C30.0692 32 31.9998 30.0695 31.9998 27.688V4.31206C31.9997 1.93055 30.0691 0 27.6876 0Z",
    fill: "#475993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_14815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.4428d5e3781909732d24d90ea411cd6a.svg";
export { ForwardRef as ReactComponent };